<template>
  <div class="ultima-resposta">
    <div
      class="ultima-resposta-container d-flex align-items-center gap-2 g-start-2"
    >
      <div class="icone">
        <i class="mdi mdi-shield-check"></i>
      </div>
      <div class="conteudo">
        <p class="descricao mb-0">{{ respostaTexto }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: "UltimaResposta",
  props: {
    pergunta: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Number, Array],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    respostaTexto() {
      if (Array.isArray(this.pergunta?.respostas) && this.pergunta.respostas.length) {
        return this.pergunta.respostas[0]?.ds_resposta || "";
      }
      return String(this.modelValue || "");
    }
  }
};
</script>

<style lang="scss" scoped>
.ultima-resposta {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, 1fr);
}
.ultima-resposta-container {
  height: 80px;
  border-radius: 8px;
  padding: 16px 18px;
  font-style: italic;
  grid-column-start: 2;
  background: #e3fce1;
  border-left: 4px solid #005312;
}

.icone {
  font-size: 30px;
  color: #005312;
}

.conteudo p {
  font-size: 14px;
  color: #005312;
  line-height: 1.2;
}

@media (max-width: 576px) {
  .ultima-resposta {
    gap: 0;
    height: 80px;
    margin-bottom: 12px;
    grid-template-columns: 1fr;
  }

  .conteudo p {
    font-size: 13px;
  }
}
</style>
